module.exports = __webpack_public_path__ + "img/35_4.b68428e7.png";